"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_TEXT_LINK = exports.INTERNAL_NO_ICON_TEXT_LINK = exports.INTERNAL_NO_ICON_BUTTON_LINK = exports.INTERNAL_BUTTON_LINK = exports.EXTERNAL_TEXT_LINK = exports.EXTERNAL_NO_ICON_TEXT_LINK = exports.EXTERNAL_NO_ICON_BUTTON_LINK = exports.EXTERNAL_BUTTON_LINK = void 0;
const EXTERNAL_BUTTON_LINK = 'External Button Link';
exports.EXTERNAL_BUTTON_LINK = EXTERNAL_BUTTON_LINK;
const EXTERNAL_NO_ICON_BUTTON_LINK = 'External No Icon Button Link';
exports.EXTERNAL_NO_ICON_BUTTON_LINK = EXTERNAL_NO_ICON_BUTTON_LINK;
const EXTERNAL_NO_ICON_TEXT_LINK = 'External No Icon Link';
exports.EXTERNAL_NO_ICON_TEXT_LINK = EXTERNAL_NO_ICON_TEXT_LINK;
const EXTERNAL_TEXT_LINK = 'External Text Link';
exports.EXTERNAL_TEXT_LINK = EXTERNAL_TEXT_LINK;
const INTERNAL_BUTTON_LINK = 'Internal Button Link';
exports.INTERNAL_BUTTON_LINK = INTERNAL_BUTTON_LINK;
const INTERNAL_NO_ICON_BUTTON_LINK = 'Internal No Icon Button Link';
exports.INTERNAL_NO_ICON_BUTTON_LINK = INTERNAL_NO_ICON_BUTTON_LINK;
const INTERNAL_NO_ICON_TEXT_LINK = 'Internal No Icon Link';
exports.INTERNAL_NO_ICON_TEXT_LINK = INTERNAL_NO_ICON_TEXT_LINK;
const INTERNAL_TEXT_LINK = 'Internal Text Link';
exports.INTERNAL_TEXT_LINK = INTERNAL_TEXT_LINK;
//# sourceMappingURL=hyperlinkStyles.js.map